import { captureErrorInApm } from '../../../lib/apm/utils/captureErrorInApm.util';
import type { ActivityFeedRowDTO } from '../../../services/modules/activityFeed/activityFeed.types';
import { indexRowsByShipment } from './activityFeedGrouping.utils';
import type { ActivityFeedSelfRefs, ResolvedActivityFeedRow } from './activityFeedPhrase.types';
import { resolveActivityFeedPhrase } from './activityFeedPhrase.utils';

const reportedRowIds = new Set<string>();

const reportUnresolvedRow = (row: ActivityFeedRowDTO) => {
  if (reportedRowIds.has(row.id)) {
    return;
  }

  reportedRowIds.add(row.id);

  captureErrorInApm.unresolvedActivityFeedRowError(
    new Error(`activity feed row of event type "${row.eventType}" resolved no phrase`),
  );
};

export const resolveActivityFeedRows = (
  rows: ActivityFeedRowDTO[],
  self?: ActivityFeedSelfRefs,
): ResolvedActivityFeedRow[] => {
  const resolvedRows: ResolvedActivityFeedRow[] = [];
  const shipments = indexRowsByShipment(rows);

  for (const row of rows) {
    const phrase = resolveActivityFeedPhrase(row, { ...self, shipments });

    if (phrase) {
      resolvedRows.push({ row, phrase });
      continue;
    }

    reportUnresolvedRow(row);
  }

  return resolvedRows;
};
